import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: 200,
    height: 110,
    borderRadius: 5,
    position: "relative",
    alignItems: "left",
    margin: 0,
  },
  root: {
    minWidth: 20,
  },

  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  Paper: {
    padding: theme.spacing(4),
  },
}));

export default useStyles;
